import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import locale from '@angular/common/locales/fr-BE';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClarityModule } from '@clr/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import {
	MSAL_GUARD_CONFIG,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG,
	MsalBroadcastService,
	MsalGuard,
	MsalInterceptor,
	MsalService
} from '@azure/msal-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConfig } from './config/app-config';
import { NotFoundModule } from './not-found/not-found.module';
import { BootstrapComponent } from './root.component';
import {
	AuthService,
	MSALGuardConfigFactory,
	MSALInstanceFactory,
	MSALInterceptorConfigFactory
} from './services/authentication/auth.service';
import { SharedModule } from './shared/shared.module';
import { initializer } from './utils/app-init';
import { HttpCustomInterceptor } from './utils/custom.httpinterceptor';
import { CdsIconModule } from '@cds/angular';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(locale);

@NgModule({
	declarations: [BootstrapComponent, AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		ClarityModule,
		NotFoundModule,
		SharedModule,
		BrowserAnimationsModule,
		ToastrModule.forRoot({
			timeOut: 4000,
			positionClass: 'toast-bottom-right'
		}),
		CdsIconModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient]
			},
			defaultLanguage: 'en'
		})
	],
	providers: [
		{ provide: LOCALE_ID, useValue: 'fr-BE' },
		{
			provide: APP_INITIALIZER,
			useFactory: initializer,
			multi: true,
			deps: [AppConfig]
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MsalInterceptor,
			multi: true
		},
		{
			// NOTE (2026-09-04): consolidated here from 6 duplicate per-lazy-module registrations
			// (bundles, export, import, products, promotions, sales-context) — see MIGRATION-LOG.md.
			// Having this multi-provider (plus a re-imported HttpClientModule) inside a lazy module's
			// own injector was breaking MsalInterceptor's token attachment for services provided in
			// those specific modules, even though MsalInterceptor is registered at root.
			provide: HTTP_INTERCEPTORS,
			useClass: HttpCustomInterceptor,
			multi: true
		},
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory
		},
		{
			provide: MSAL_GUARD_CONFIG,
			useFactory: MSALGuardConfigFactory
		},
		{
			provide: MSAL_INTERCEPTOR_CONFIG,
			useFactory: MSALInterceptorConfigFactory
		},
		MsalService,
		MsalGuard,
		MsalBroadcastService,
		AuthService
	],
	bootstrap: [BootstrapComponent]
})
export class AppModule {}
